import { QueryClient } from "@tanstack/react-query"

/**
 * Single shared QueryClient — created here (not inside a provider) so
 * beforeLoad guards can ensureQueryData the session BEFORE the React tree
 * mounts, and mutations anywhere invalidate the same cache.
 * Defaults mirror components/providers/query-provider.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status
        if (status === 401 || status === 403) return false
        return failureCount < 1
      },
    },
  },
})
